<app-bulgari-background></app-bulgari-background>
<div class="container h-100">
  <div class="row h-100 justify-content-center align-items-center">
    <div class="col-lg-4">
      <div class="card">
        <div class="card-body">

          <img src="./../../../assets/images/logo-full-saffron.svg" class="card-img-top" alt="BULGARI">
          <h5 class="card-title">{{'SELECT STORE'|translate}}</h5>

          @if(!choosingStore){
          <button class="btn btn-light btn-lg dropdown-toggle" type="button" (click)="handleSelectStoreClick()">
            @if(isStoreSelected){
            {{'Select your store'|translate}}
            }@else {
            {{store?.nameStore}}
            }
          </button>
          <div class="d-grid">
            <button type="button" class="btn btn-primary btn-lg" (click)="handleDoneClick()"
              [disabled]="isStoreSelected">
              {{'DONE'|translate}}
            </button>
          </div>

          }@else {

          <div class="input-group">
            <span class="input-group-text">

              @if(loading){
              <div class="spinner-border text-primary mx-auto" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>

              }@else {

              <img src="./../../../assets/icons/search-black.svg" alt="Search">
              }

            </span>
            <input #input type="text" class="form-control" placeholder="Type to search" [formControl]="searchControl">
          </div>
          <ul class="list-group">

            @for (store of filteredStores$ | async; track store.idStore; let i = $index){
            <li class="list-group-item" [class.selected]="isSelectedStore === store.idStore"
              (click)="handleSelectStore(store)">
              {{store.codeStore}}&nbsp;-&nbsp;{{ store.nameStore }}
            </li>
            }

          </ul>
          <div class="d-grid">
            <button type="button" class="btn btn-primary btn-lg" (click)="handleChooseClick()"
              [disabled]="isSelectedStoreSelected">
              {{'CHOOSE'|translate}}
            </button>
          </div>

          }
        </div>

      </div>
    </div>
  </div>
</div>
